import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RootComponent } from './root/root.component';
import { SubComponent } from './sub/sub.component';
import { CategoryproductsComponent } from './categoryproducts/categoryproducts.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { NgbRatingModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { MatSliderModule } from '@angular/material/slider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatBadgeModule } from '@angular/material/badge';
import {AppCommonModule} from "../common/common.module";



@NgModule({
  declarations: [
    RootComponent,
    SubComponent,
    CategoryproductsComponent
  ],
  imports: [
    CommonModule,
    ScrollingModule,
    NgbRatingModule,
    NgxSliderModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatBadgeModule,
    AppCommonModule
  ]
})
export class CategoriesModule { }
